

// localstorage 存储的 key（存在在本地，key不使用过于直白标记，避免用户根据命名去尝试）
const UserInfoKey = 'user'
const RouterKey = 'router'
const RouterLastKey = 'lastRouter'
export default {
    /**
     * @description: 读取用户缓存信息数据 
     * @param {*}
     * @return {*}
     */
    readUserInfo() {
        return JSON.parse(localStorage.getItem(UserInfoKey))
    },



    /**
        * @description: 存用户信息
        * @param {*} info
        * @return {*}
        */
    storeUserinfo(info) {
        localStorage.setItem(UserInfoKey, JSON.stringify(info))
    },
    /**
   * @description: 存router上一个记录
   * @param {*} info
   * @return {*}
   */
    storeLastRouter(info) {
        localStorage.setItem(RouterLastKey, JSON.stringify(info == undefined ? 'Home' : info))
    },
    /**
   * @description: router上一个记录
   * @return {*}
   */
    readLastRouter() {
        return JSON.parse(localStorage.getItem(RouterLastKey)) == null ? "/" : JSON.parse(localStorage.getItem(RouterLastKey))
    },
    /**
    * @description: 登录前存router记录
    * @param {*} info
    * @return {*}
    */
    storeRouterSession(info) {
        localStorage.setItem(RouterKey, JSON.stringify(info))
    },
    /**
   * @description: router记录
   * @return {*}
   */
    readRouterSession() {
        return JSON.parse(localStorage.getItem(RouterKey)) == null ? "/" : JSON.parse(localStorage.getItem(RouterKey))
    },
}
